var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.7,
    width: 6,
    height: 6,
    rx: 1,
    ry: 1,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.89,
    y: 13.7,
    width: 6,
    height: 6,
    rx: 1,
    ry: 1,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,14.71l.03.03-.03,4.1-4.22-.03.03-4.1h4.19M12.1,13.71h-4.19c-.57,0-1.03.46-1.03,1.03v4.07c0,.57.46,1.03,1.03,1.03h4.19c.57,0,1.03-.46,1.03-1.03v-4.07c0-.57-.46-1.03-1.03-1.03h0Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.65,5.96C16.35,1.9,12.98,0,9.79,0c-2.51,0-4.95,1.15-6.7,3.16C1.07,5.47,0,8.78,0,12.73v.38l3.64-.03v-.37c-.02-3.91,1.28-6.93,3.57-8.29,1.53-.91,3.29-.94,4.73-.07.91.55,1.59,1.41,2.01,2.49l-2.24.53,5.72,6.34,2.47-8.28-2.25.53Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.17af42d03533235f7947872e9f271133.svg";
export { ForwardRef as ReactComponent };